<!-- src/routes/NotFound.svelte -->
<h1>Page Not Found</h1>
<p><a href="#/">Go back to HQ</a></p>